export const formatStringDecimal = (string, decimalLength) => {
    const index = string.indexOf(".");
    if (index === -1) return string
    const preDecimalString = string.substring(0, index)
    const postDecimalString = string.slice(index, index+1+parseInt(decimalLength))
    const formattedString = preDecimalString + postDecimalString
    return formattedString
};
